<script setup>
  import { ref, computed, onMounted, getCurrentInstance } from 'vue';
  import { useRoute } from 'vue-router';
  import { usePageLoadingStore } from "../../../../../stores/pageLoading";
  import JobFairStudentInfoTabView from './JobFairStudentInfoTabView.vue';
  import JobFairStudentResumeTabView from './JobFairStudentResumeTabView.vue';
  import JobFairStudentJobApplicationsTabView from './JobFairStudentJobApplicationsTabView.vue';
  import JobFairStudentIntvOffersTabView from './JobFairStudentIntvOffersTabView.vue';
  import adminJobfairStateService from '../../../services/jobfair/adminJobfairStateService';

  const route = useRoute();
  const loadingStore = usePageLoadingStore();
  const { $toast } = getCurrentInstance().appContext.config.globalProperties;
  const tabRef = ref(null);

  const tabCount = ref({
    totalCnt21: 0,
    totalCnt22: 0,
    totalCnt23: 0,
    totalCnt24: 0,
  });

  const tabOptions = computed(() => [
    { label: `회원정보(${tabCount.value.totalCnt21})`, value: 'student-info' },
    { label: `이력서(${tabCount.value.totalCnt22})`, value: 'resume' },
    { label: `입사지원(${tabCount.value.totalCnt23})`, value: 'job-applications' },
    { label: `받은 면접제안(${tabCount.value.totalCnt24})`, value: 'interview-offers' }
  ]);

  const selectedTabValue = ref(tabOptions.value[0].value);

  const onChangeTab = (tab) => {
    selectedTabValue.value = tab.value;
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("tab2", tab.value);
    window.history.replaceState({}, "", `${window.location.pathname}?${queryParams.toString()}`);
  };

  // TAB 옆 count
  const retrieveJobFairStuTabCount = () => {
    loadingStore.loading = true;
    adminJobfairStateService.retrieveJobFairStuCount()
      .then( async (res) => {
        loadingStore.loading = false;
        if (res.data.code.toLowerCase() === "success") {
          const result = res.data.result;
          tabCount.value = {
            totalCnt21: result.totalCnt21,
            totalCnt22: result.totalCnt22,
            totalCnt23: result.totalCnt23,
            totalCnt24: result.totalCnt24,
          }
        }
      })
      .catch((res) => {
        $toast("error", res);
      });
  };

  onMounted(() => {
    const tabFromQuery = route.query.tab2;
    if (tabFromQuery && tabOptions.value.some(opt => opt.value === tabFromQuery)) {
      selectedTabValue.value = tabFromQuery;

      if(tabRef.value) {
        tabRef.value.init(tabFromQuery);
      }
    } else {
      selectedTabValue.value = tabOptions.value[0].value;
      if(tabRef.value) {
        tabRef.value.init(tabOptions.value[0].value);
      }

      const queryParams = new URLSearchParams(window.location.search);
      queryParams.set("tab2", tabOptions.value[0].value);
      window.history.replaceState({}, "", `${window.location.pathname}?${queryParams.toString()}`);
    }
    retrieveJobFairStuTabCount();
  });
</script>

<template>
  <div>
    <div class="tab-wrap">
      <KSATab
        ref="tabRef"
        :options="tabOptions"
        @change="onChangeTab"
        style="grid-template-columns: repeat(4, 1fr);"
      />
    </div>
    <div v-if="selectedTabValue === 'student-info'">
      <JobFairStudentInfoTabView />
    </div>
    <div v-else-if="selectedTabValue === 'resume'">
      <JobFairStudentResumeTabView />
    </div>
    <div v-else-if="selectedTabValue === 'job-applications'">
      <JobFairStudentJobApplicationsTabView />
    </div>
    <div v-else-if="selectedTabValue === 'interview-offers'">
      <JobFairStudentIntvOffersTabView />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tab-wrap {
  margin-bottom: 20px;
}
</style>
